import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLocalization } from 'hooks/useLocalization';
import { useBusiness } from 'hooks/useBusiness';
import { Box, Paper, Collapse } from '@mui/material'
import PageLoader from 'components/shared/PageLoader';
import AlertBig from 'components/shared/AlertBig';

function AwaitingPayment() {
	const {
		bookingNumber: bookingNumberString,
		bookingToken,
		gatewayCode,
		redirectId: redirectIdString
	} = useParams<{
		bookingNumber?: string,
		bookingToken?: string,
		gatewayCode?: string,
		redirectId?: string
	}>();
	
	const { sendRequest, getBizConfigVar, setPageTitle } = useBusiness();
	const [paymentStatus, setPaymentStatus] = useState<'loading' | 'received' | 'error'>('loading');
	const [errorString, setErrorString] = useState<string | null>(null);
	
	const bizContactEmails = getBizConfigVar('bizContactEmails');
	
	const bookingNumber = bookingNumberString ? parseInt(bookingNumberString) : undefined;
	const redirectId = redirectIdString ? parseInt(redirectIdString) : undefined;

	const { getStr, langCode } = useLocalization();
	
	useEffect(() => {
        const checkPaymentStatus = () => {
			console.log('params:');
			console.log({
                    bookingNumber: bookingNumber,
					gatewayCode: gatewayCode,
                    redirectId: redirectId
                });

            sendRequest({
                type: 'checkPayment',
                params: {
                    bookingNumber: bookingNumber,
					gatewayCode: gatewayCode,
                    redirectId: redirectId
                },
                onSuccess: (data) => {
                    if (data.checkPayment.isReceived) {
                        setPaymentStatus('received');
						setPageTitle(getStr('Payment_received'));
                        clearInterval(intervalId);
                    }
                },
                onError: (errorMessage) => {
                    setPaymentStatus('error');
                    setErrorString(errorMessage);
                    clearInterval(intervalId);
                }
            });
        };

        // Send the request immediately on page load
        checkPaymentStatus();

        // Then set up the interval to repeat every 5 seconds
        const intervalId = setInterval(checkPaymentStatus, 5000);

		// Cleanup interval on component unmount
		return () => clearInterval(intervalId);
	  }, []);

	return (
		<>
			<Collapse in={paymentStatus === 'loading'}>
				<PageLoader />
				<AlertBig
					title={getStr('Waiting_for_payment_confirmation')}
				>
					{getStr('WAITING_FOR_PAYMENT_CONFIRMATION_INFO')}
				</AlertBig>
			</Collapse>
			<Collapse in={paymentStatus === 'received'}>
				<AlertBig
					severity="success"
					title={getStr('Thank_you_EXCL')}
				>
					{getStr('Payment_recieved_booking_confirmed')} {getStr('If_we_can_help_out_dont_hesitate_to')} {bizContactEmails.length > 0 ? (<a href={`mailto: ${bizContactEmails.join(',')}`}>{getStr('IF_CAN_HELP_PLEASE_DONT_HESITATE_TO_contact_us')}</a>) : (getStr('IF_CAN_HELP_PLEASE_DONT_HESITATE_TO_contact_us'))}.
				</AlertBig>
			</Collapse>
			<Collapse in={paymentStatus === 'error'}>
				<AlertBig
					severity="error"
					title={getStr('Error')}
				>
					<Box>
						{getStr('ERROR_TRY_AGAIN_OR_CONTACT_ERROR_INFO_RETRIEVED_PART_1')} <a href={getBizConfigVar('appRootUrlToUse') + '/#/' + getStr('PUBLIC_APP_URL_booking') + '/' + bookingNumber + '/' + bookingToken}>{getStr('ERROR_TRY_AGAIN_OR_CONTACT_ERROR_INFO_RETRIEVED_PART_2_try_again')}</a> {getStr('ERROR_TRY_AGAIN_OR_CONTACT_ERROR_INFO_RETRIEVED_PART_3')}:
					</Box>
					<Paper sx={{ backgroundColor: 'transparent', padding: '10px', mt: '15px' }}><i>{errorString}</i></Paper>
				</AlertBig>
			</Collapse>
		</>
	);
}

export default AwaitingPayment;